<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading"
        v-if="
        this.getDetailLink.epdid !== undefined &&
        this.getDetailLink.epdid !== ''
        ">
          <div class="ml-4">
            {{getDetailLink.ept}}
          </div>
          <v-spacer/>
          <div class="mr-4">
            Rev {{getDetailLink.eprev}}
          </div>
        </v-layout>
        <Results/>
        <v-layout row class="mt-3 mr-2">
          <v-spacer/>
          <DocumentInfoCard
          v-if="this.getDetailLink.epdid !== undefined && this.getDetailLink.epdid !== ''"
          :data="{
            btn: 'icon',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: this.getUser.pref.select.fdid,
            did: this.getDetailLink.epdid,
            tag: 'E6'}"
          />
          <Append :data="{tag: 'E6'}"
          v-if="this.enableResultsTemplate"
          />
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import Results from "@/engineering/results/components/Results";
import Append from "@/data/append/components/Append";
import { mapGetters } from "vuex";
import DocumentInfoCard from "@/document/info/components/DocumentInfoCard";
export default {
  components: {
    Results,
    Append,
    DocumentInfoCard
  },
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getDetailLink",
      "getUser",
      "getCurrentPage",
      "getPreviousPage"
    ]),
    enableResultsTemplate() {
      let logic = null;
      if (this.getCurrentPage === "/reportdetail") {
        if (
          this.getDetailChar.stat === true ||
          this.getPreviousPage === "/reportlist" ||
          this.getPreviousPage === "/reportdetaillist"
        ) {
          logic = false;
        } else {
          logic = true;
        }
      } else if (this.getCurrentPage === "/worktooldetail") {
        let flow = this.getDetail.trans.flow;
        let transStatus = flow[flow.length - 1].title;
        if (transStatus === "Closed" || transStatus === "Cancelled") {
          logic = false;
        } else {
          logic = true;
        }
      } else if (this.getDetail.basic.tag === "W2") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    }
  }
};
</script>
